export default __webpack_public_path__ + "static/media/round-24-offline.a6cf3d5b.svg";